import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useStore, useToast } from "@/comn/hooks";
import { URLS, APIS, SF_PTLI0310001S, SG_FAQ_MGMT_LIST } from "@/tra/tancis/ptli/cmnty/qna/services/PtliQnaService";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*
 * Role Management List
 * !== 역할 관리 목록 ==!
 */
export const PTLI0310001S = (): JSX.Element => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */ 0;
    const pgeUid = "UI-PTLI-0313-001Q"; // Page Unique identifier !== 화면 고유 식별자 ==!
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const { boardId } = useParams();

    const form = {
        qnaLang: useForm({
            defaultSchema: SF_PTLI0310001S,
            defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    // const grid = {
    //     faqList: useGrid({
    //         defaultSchema: SG_FAQ_MGMT_LIST,
    //         page: pgeStore?.page,
    //         size: pgeStore?.size,
    //     }),
    // };

    const fetch = {
        getQnaInfo: useFetch({
            api: (data) => APIS.getQnaInfo(boardId),

            enabled: !!boardId,
            //key: [grid.faqList.page, grid.faqList.size],
            onSuccess: (data) => {
                const qnaLang = data.boardInfo.content;
                // alert(data.faqLang.content);
                // alert(faqLang);
                form.qnaLang.setValues(qnaLang);
                console.log(qnaLang);
            },
        }),
    };

    console.log(fetch);

    const handler = {
        onListBtnClick: () => navigate(URLS.ptli0310001q),
    };

    useEffect(() => {
        //  alert("---");
        fetch.getQnaInfo.fetch();
        form.qnaLang.setEditable(false);
    }, []);

    return (
        <Page
            id={pgeUid}
            title={t("T_FAQ")}
            navigation={{
                base: comnEnvs.base,
                nodes: [
                    { label: "Portal" },
                    { label: "Internal Portal Management" },
                    { label: "My Page" },
                    { path: "/iptm/mypg/ptli0313001q", label: "FAQ" },
                ],
            }}
        >
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.sysCat} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.faq} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.boardTitle} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.boardContent} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.attachment} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.boardPublic} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.qnaLang.schema.frstRegstId} />
                            <Group.Control {...form.qnaLang.schema.frstRgsrDtm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Layout.Button role={"list"} onClick={() => handler.onListBtnClick()} />
                        </Layout.Left>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
